export { default } from './CopyrightContainer';
